
import { Vue, Component, Prop } from 'vue-property-decorator'
import UserAvatar from '@/views/Project/Observation/components/userAvatar.vue'

import { visibilityIcons } from '@/types/observation'

@Component({
    components: {
        UserAvatar,
    },
})
export default class RestrictedToLabel extends Vue {
    @Prop({ required: true }) observation!: any
    @Prop({ default: 20 }) size!: number
    @Prop({ default: false }) clickable!: boolean

    restrictedIcon = visibilityIcons.restricted

    get isRestrictedTo() {
        return this.observation?.visibility == 'restricted' ? true : false
    }
}
